import type { MouseEvent } from 'react'

import { useStore } from '@nanostores/react'
import { CustomTip } from 'components/atoms/tooltipCustom'
import ModalWindow from 'components/molecules/ModalWindow'
import { CONSTS } from 'config/objectConst'
import { atom } from 'nanostores'
import { ContactsTable } from 'shared/ui'

import type { ActionWithId } from '../../types'

import { api } from '../../api'

const $openId = atom('')

export function Stop({ enabled, hint, id }: ActionWithId) {
	return (
		<CustomTip arrow title={hint}>
			<button
				className={ContactsTable.css.cellAction}
				disabled={!enabled}
				onClick={openOnClick}
				type='button'
				value={id}
			>
				<svg
					aria-hidden
					fill='currentcolor'
					height={18}
					viewBox='0 0 18 18'
					width={18}
				>
					<rect height={12} rx={1} width={12} x={2} y={2} />
				</svg>
			</button>
		</CustomTip>
	)
}

export function StopModal() {
	const openedId = useStore($openId)
	const [complete, { isLoading }] = api.useCompleteExecutionMutation()

	return (
		<ModalWindow
			closeText='No'
			confirmText='Yes'
			loading={isLoading}
			open={Boolean(openedId)}
			{...CONSTS.confirmationDialogs[1.1]}
			closeHandler={resetStore}
			confirmHandler={async () => {
				const { data } = await complete(openedId)

				if (data) {
					resetStore()
				}
			}}
		/>
	)
}

function openOnClick(event: MouseEvent<HTMLButtonElement>) {
	const nextID = event.currentTarget.value
	$openId.set(nextID)
}

function resetStore() {
	$openId.set('')
}
